import axios from "axios";
import { updateUserProfile } from "../store/authSlice";

function pickProfile(data) {
  if (!data || typeof data !== "object") return null;
  if (data.profile && typeof data.profile === "object") return data.profile;
  if (data.user && typeof data.user === "object") return data.user;
  if (data.result && typeof data.result === "object" && !Array.isArray(data.result)) {
    return data.result;
  }
  if (data.data && typeof data.data === "object" && !Array.isArray(data.data)) {
    return data.data;
  }
  if (data._id || data.id || data.userid || data.email || data.name) return data;
  return null;
}

function getProfileImageUrl(p) {
  return String(p?.profileImage || p?.image || p?.avatar || "").trim();
}

/**
 * Fetch getProfile and sync name + profileImage into Redux / localStorage
 * so Header avatar is available right after login (without opening Profile).
 */
export async function syncUserProfileFromApi(dispatch, userId) {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const id = String(userId || "").trim();
  if (!API_BASE_URL || !id || typeof dispatch !== "function") {
    return null;
  }

  try {
    const response = await axios.post(`${API_BASE_URL}`, {
      action: "getProfile",
      userId: id
    });
    const data = response?.data;
    if (!(data?.status === "success" || data?.success === true)) {
      return null;
    }

    const p = pickProfile(data);
    if (!p) return null;

    const name = String(p?.name || p?.fullName || "").trim();
    const profileImage = getProfileImageUrl(p);

    const { persistInviteDomainFromProfile } = await import("./inviteDomain");
    persistInviteDomainFromProfile(p);

    dispatch(
      updateUserProfile({
        ...(name ? { name } : {}),
        profileImage
      })
    );

    return { name, profileImage };
  } catch {
    return null;
  }
}
